module.exports = "<app-content-page></app-content-page>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/dashboard/dashboard.component.html
// module id = ../../../../../src/app/dashboard/dashboard.component.html
// module chunks = main